import {
  average,
  averageCadence,
  averageWeeklyDistance, averageWeeklySessions,
  calendarRange,
  pace,
} from '../../lib/functions';

export default {
  trainingOverviewMetrics: (state, getters) => (start, end) => (getters.roster || []).reduce(
    (a, m) => ({
      ...a,
      [m.memberId]: {
        workload: (m.metrics.find(d => d.date.isSame(end, 'day')) || {}).ebAcr,
        cadence: averageCadence(m.metrics
          .filter(calendarRange(start, end))
          .reduce((aa, d) => aa.concat(d.activities || []), [])),
        distance: averageWeeklyDistance(m.metrics.filter(calendarRange(start, end))) || null,
        pace: pace(m.metrics.filter(calendarRange(start, end)), false, false),
        power: m.metrics
          .filter(calendarRange(start, end))
          .map(d => d.criticalPower / m.weight)
          .reduce(average, 0) || null,
        sessions: averageWeeklySessions(m.metrics.filter(calendarRange(start, end))) || null,
      },
    }), {},
  ),
};
